<template>
	<div class="wizard-page">
		<svg
			width="209"
			height="32"
			viewBox="0 0 209 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="logo-gradient-white-jira-software">
				<path d="M0 0H209V32H0V0Z" fill="white" fill-opacity="0.01" />
				<g id="Jira Software">
					<path
						d="M39.1359 4.32456H41.9646V19.1742C41.9646 23.0897 40.2817 25.8232 36.3789 25.8232C34.9108 25.8232 33.765 25.5647 32.9773 25.2691V22.4248C33.8366 22.7942 34.875 22.9789 35.9134 22.9789C38.3124 22.9789 39.1359 21.5013 39.1359 19.3589V4.32456Z"
						fill="white"
					/>
					<path
						d="M47.1207 3.17942C48.2307 3.17942 49.0184 3.88127 49.0184 5.13721C49.0184 6.3562 48.2307 7.09499 47.1207 7.09499C46.0107 7.09499 45.223 6.39314 45.223 5.13721C45.223 3.88127 46.0107 3.17942 47.1207 3.17942ZM45.7601 9.42217H48.4813V25.6755H45.7601V9.42217Z"
						fill="white"
					/>
					<path
						d="M55.2129 25.6755H52.5632V9.42216H55.2129V12.2665C56.1439 10.3456 57.7193 8.97889 60.7986 9.16358V11.8971C57.3255 11.5277 55.2129 12.5989 55.2129 16.0712V25.6755Z"
						fill="white"
					/>
					<path
						d="M73.4739 22.7573C72.4713 24.8997 70.5736 26.0079 68.1388 26.0079C63.9495 26.0079 61.8369 22.3509 61.8369 17.5488C61.8369 12.9683 64.0569 9.08971 68.461 9.08971C70.7526 9.08971 72.5429 10.161 73.4739 12.2665V9.42216H76.1952V25.6755H73.4739V22.7573ZM68.8549 23.3852C71.2897 23.3852 73.4381 21.7968 73.4381 18.1768V16.8839C73.4381 13.2639 71.4688 11.6755 69.1414 11.6755C66.0978 11.6755 64.5224 13.7441 64.5224 17.5119C64.5582 21.4644 66.062 23.3852 68.8549 23.3852Z"
						fill="white"
					/>
					<path
						d="M92.2363 26.0079C88.226 26.0079 86.3641 25.1953 84.7528 24.3457V21.3536C86.6863 22.3879 89.6224 23.1267 92.3795 23.1267C95.4946 23.1267 96.6762 21.8707 96.6762 19.9868C96.6762 18.1029 95.5304 17.1056 91.5918 16.1082C86.937 14.9261 84.8602 13.2639 84.8602 9.75464C84.8602 6.4301 87.3308 3.95516 92.1289 3.95516C95.1366 3.95516 97.0343 4.69395 98.4665 5.50661V8.42482C96.3898 7.20582 94.134 6.79949 92.0214 6.79949C89.3002 6.79949 87.6889 7.75991 87.6889 9.7177C87.6889 11.4908 89.0137 12.3404 92.6659 13.3008C97.0343 14.4459 99.5049 15.8866 99.5049 19.7283C99.5049 23.4961 97.3565 26.0079 92.2363 26.0079Z"
						fill="white"
					/>
					<path
						d="M101.904 17.5119C101.904 12.6359 104.661 9.08971 109.387 9.08971C114.078 9.08971 116.835 12.6359 116.835 17.5119C116.835 22.3879 114.078 26.0079 109.387 26.0079C104.661 26.0079 101.904 22.3879 101.904 17.5119ZM104.554 17.5119C104.554 20.6148 106.022 23.3852 109.423 23.3852C112.753 23.3852 114.221 20.5778 114.221 17.5119C114.221 14.4459 112.789 11.6755 109.423 11.6755C106.022 11.7124 104.554 14.4459 104.554 17.5119Z"
						fill="white"
					/>
					<path
						d="M127.828 9.42215V12.0079H123.746V25.6755H121.096V12.0079H118.518V9.42215H121.06V7.64907C121.06 4.62004 122.707 2.58838 126.073 2.58838C126.897 2.58838 127.434 2.73614 127.899 2.84695V5.43271C127.434 5.32189 126.825 5.28495 126.181 5.28495C124.498 5.28495 123.674 6.28231 123.674 7.75988V9.42215H127.828Z"
						fill="white"
					/>
					<path
						d="M136.958 23.0528C137.603 23.0528 138.176 22.905 138.677 22.8312V25.5277C138.211 25.6755 137.674 25.7863 136.851 25.7863C133.485 25.7863 131.838 23.7546 131.838 20.7256V12.0079H129.26V9.42218H131.802V5.98682H134.452V9.42218H138.641V12.0079H134.452V20.6148C134.488 22.0554 135.275 23.0528 136.958 23.0528Z"
						fill="white"
					/>
					<path
						d="M157.009 25.6755L154.288 17.8074L152.856 12.7836L151.424 17.8074L148.702 25.6755H145.229L139.429 9.42215H142.436L146.984 23.2005L151.567 9.42215H154.145L158.728 23.2005L163.276 9.42215H166.283L160.483 25.6755H157.009Z"
						fill="white"
					/>
					<path
						d="M178.636 22.7573C177.634 24.8997 175.736 26.0079 173.301 26.0079C169.112 26.0079 166.999 22.3509 166.999 17.5488C166.999 12.9683 169.219 9.08971 173.623 9.08971C175.915 9.08971 177.705 10.161 178.636 12.2665V9.42216H181.358V25.6755H178.636V22.7573ZM174.053 23.3852C176.488 23.3852 178.636 21.7968 178.636 18.1768V16.8839C178.636 13.2639 176.667 11.6755 174.34 11.6755C171.296 11.6755 169.721 13.7441 169.721 17.5119C169.721 21.4644 171.26 23.3852 174.053 23.3852Z"
						fill="white"
					/>
					<path
						d="M188.089 25.6755H185.44V9.42216H188.089V12.2665C189.02 10.3456 190.596 8.97889 193.675 9.16358V11.8971C190.202 11.5277 188.089 12.5989 188.089 16.0712V25.6755Z"
						fill="white"
					/>
					<path
						d="M203.235 26.0079C197.327 26.0079 194.749 22.4987 194.749 17.5119C194.749 12.5989 197.399 9.08971 202.197 9.08971C207.066 9.08971 209 12.562 209 17.5119V18.7678H197.506C197.9 21.5383 199.619 23.3113 203.343 23.3113C205.169 23.3113 206.708 22.942 208.141 22.4248V25.0106C206.816 25.7493 204.846 26.0079 203.235 26.0079ZM197.47 16.3668H206.243C206.1 13.3377 204.775 11.6385 202.054 11.6385C199.189 11.6385 197.757 13.5594 197.47 16.3668Z"
						fill="white"
					/>
				</g>
				<g id="Icon">
					<path
						id="Vector"
						d="M13.105 29.0001C15.7547 26.2666 15.7547 21.8708 13.105 19.1373L4.33253 10.0872L0.322255 14.2244C-0.107418 14.6676 -0.107418 15.3695 0.322255 15.7758L13.105 29.0001Z"
						fill="white"
					/>
					<path
						id="Vector_2"
						d="M25.9236 14.2243L13.105 1L13.0692 1.03694C10.4554 3.77045 10.4554 8.16623 13.105 10.8628L21.9133 19.9129L25.9236 15.7757C26.3533 15.3325 26.3533 14.6306 25.9236 14.2243Z"
						fill="white"
					/>
					<path
						id="Vector_3"
						d="M13.1049 10.8627C10.4911 8.16615 10.4553 3.77037 13.0691 1.03687L3.97437 10.4564L8.73657 15.3693L13.1049 10.8627Z"
						fill="url(#paint0_linear)"
					/>
					<path
						id="Vector_4"
						d="M17.5091 14.5936L13.105 19.1372C15.7546 21.8707 15.7546 26.2665 13.105 29L22.2713 19.5435L17.5091 14.5936Z"
						fill="url(#paint1_linear)"
					/>
				</g>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear"
					x1="12.9058"
					y1="6.14941"
					x2="7.19361"
					y2="11.6863"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0.0680226"
						stop-color="white"
						stop-opacity="0.4"
					/>
					<stop offset="1" stop-color="white" />
				</linearGradient>
				<linearGradient
					id="paint1_linear"
					x1="13.4682"
					y1="23.6972"
					x2="19.7233"
					y2="17.634"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0.0680226"
						stop-color="white"
						stop-opacity="0.4"
					/>
					<stop offset="0.9077" stop-color="white" />
				</linearGradient>
			</defs>
		</svg>
		<div class="sub-title-area">
			<svg
				class="sub-title-icon"
				width="12"
				height="12"
				viewBox="0 0 12 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM4.8 9.00094L1.8 6.00094L2.64 5.16094L4.8 7.32094L9.36 2.76094L10.2 3.60094L4.8 9.00094Z"
					fill="#E0E2E8"
				/>
			</svg>
			<div class="sub-title-text">Visor is a secure partner of Jira</div>
		</div>
		<h2 class="wizard-page-title">
			Save time by importing Jira fields and project data directly into
			Visor.
		</h2>
		<div class="page-body">
			<div class="bottom-button" @click="goNext('jira')">
				{{ continueText }}
			</div>

			<div class="secondary-button" @click="goNext('manual')">
				Continue without Jira
			</div>
		</div>
	</div>
</template>

<script>
import WindowsUtil from 'js/utils/windows';
import ConnectedApps from 'js/connected-apps/connected-apps';
import {
	manifest,
	goals,
	recordTypes,
	customizations,
} from 'js/quickstart/sheet-wizard-manifest.js';

export default {
	data() {
		return {};
	},
	$pubsub: {
		wizard: {},
	},
	props: {
		dataStore: {
			required: true,
			type: Object,
		},
		sheetView: {
			required: true,
			type: Object,
		},
		sheetWizardProperties: {
			required: true,
			type: Object,
		},
	},
	mounted() {},
	computed: {
		jiraConnected() {
			return ConnectedApps.services.jira.isConnected();
		},
		continueText() {
			if (this.jiraConnected) {
				return 'Include Jira Data';
			}
			return 'Continue to Jira';
		},
	},
	methods: {
		goNext(userSelection) {
			if (!this.jiraConnected && userSelection === 'jira') {
				// open the new window
				ConnectedApps.services.jira.openLinkToAuthorizeConnectedAppService();
			}

			this.sheetWizardProperties.useJira = userSelection === 'jira';
			this.$pubsub.modules.wizard.pub('advanceWizard');
		},
	},
};
</script>

<style lang="scss" scoped>
.wizard-page {
	background-color: #0052cc;
	padding: 18px;

	.page-brand {
		position: relative;
		top: -6px;
		left: -6px;
	}

	.wizard-page-question {
		font-style: normal;
		font-weight: normal;
		font-size: 18px;
		line-height: 28px;
		text-align: center;
		letter-spacing: 0.15px;
		color: $p-color-grey-600;
		margin: 0;
		margin-bottom: 9px;
		margin-top: 36px;
		cursor: default;
		padding: 0 12px;
	}

	.wizard-page-title {
		font-family: $rvFontFamily;
		font-size: 24px;
		line-height: 36px;
		text-align: center;
		letter-spacing: 0.15px;
		color: $p-color-white;
		width: 480px;
		margin: auto;
		cursor: default;
		user-select: none;
	}

	.sub-title-area {
		margin: auto;
		margin-bottom: 12px;
		margin-top: 54px;
		padding: 0 12px;
		width: 480px;
		text-align: center;
		cursor: default;
		user-select: none;

		.sub-title-icon {
			margin-right: 9px;
			margin-left: 6px;
		}

		.sub-title-text {
			display: inline;
			font-family: $rvFontFamily;
			font-size: 16px;
			line-height: 24px;
			text-align: center;
			letter-spacing: 0.15px;
			color: $p-color-grey-100;
		}
	}

	.tile-selection {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
	}

	.description-text {
		margin: auto;
		margin-top: 42px;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		letter-spacing: 0.15px;
		color: $p-color-grey-500;
		max-width: 500px;
		padding: 0 12px 42px 12px;
	}

	.page-body {
		@include flex(column, center);
		margin-top: 63px;

		.image-container {
			width: 540px;
			flex-grow: 1;
			margin-bottom: 97px;

			.explain-image {
			}
		}
	}

	.bottom-button {
		@include clickable;

		font-family: $rvFontFamily;
		font-weight: 600;
		font-size: 18px;
		line-height: 48px;
		text-align: center;
		letter-spacing: 0.15px;
		color: $p-color-white;

		border: 1px solid $p-color-white;
		box-sizing: border-box;
		border-radius: 3px;
		width: 400px;
		margin: 0 auto;
		cursor: pointer;
		margin-bottom: 48px;
	}

	.secondary-button {
		@include clickable;

		font-family: $rvFontFamily;
		font-weight: 600;
		font-size: 18px;
		line-height: 26px;
		text-align: center;
		letter-spacing: 0.15px;
		color: $p-color-grey-300;
		cursor: pointer;
	}
}
</style>
